import React from 'react'
import axios from '../../../../data/http/axios'
import { connect, useSelector } from 'react-redux'
import BBNotifications from './bb_notifications/bb_notifications'
import BBAccount from './bb_account/bb_account'
import BBMobileNav from './bb_mobileNav/bb_mobileNav'
import BBStandardNav from './bb_standardNav/bb_standardNav'
import Banner from './banner'
import Mailchimp2ImportBar from './mailchimp2ImportBar'
import { Translation } from 'react-i18next'
import CompanySelect from './bb_topNav_CompanySelect'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Modal from '~/Common-Objects/Modal/index'
import useNotifications from '~/Common-Objects/Notifications/notifications'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import CreateCampaign from '../../campaigns/add/drawerAddCampaignStep1'
import CreateTemplate from '../../templates/add/templatesAdd'
import CreateForm from '../../forms/GroupSelect'
import AddSubs from '../../subscribers/addSubs'

import PermissionChecker from '../../../../Classes/permissions'
import NewUserForm from './newUserForm/newUserForm'
import moment from 'moment'
import queryString from 'query-string'

import PremiumSupport from './premiumSupportDrawer'
import UpgradeDrawer from '../upgrade/upgradeTiers'
import Suggestion from './suggestion'
import BBMobileCompanySelect from './bbMobileCompanySelect'

/*add campaign dialogue*/
import DrawerAddCampaignStep1 from '~/pages/cp/campaigns/add/drawerAddCampaignStep1'

import FeedbackPopups from './feedbackpopups'
import AppSwitcher from './appSwitcher'
import CreateAutomationModal from '../automations/createAutomationModal'

@connect((store) => {
    return {
        user: store.user,
        browser: store.browser,
        accountMaster: store.accountMaster,
        siteMaster: store.siteMaster,
        permissionStore: store.permission
    }
})
class BBTopNav extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            drawer: null,
            changingAccounts: false,
            showSwitchModal: false,
            createOpen: false,
            switchAccountContent: '',
            counts: {
                support: 0
            },
            lastCheck: moment()
        }
        this.addNewCampaign = this.addNewCampaign.bind(this)
        this.changeAccount = this.changeAccount.bind(this)
        this.setChangingAccounts = this.setChangingAccounts.bind(this)
        this.goUpgrade = this.goUpgrade.bind(this)
        this.goPremiumSupport = this.goPremiumSupport.bind(this)
        this.suggestion = this.suggestion.bind(this)
        this.createNew = this.createNew.bind(this)
        this.hasPermission = this.hasPermission.bind(this)
        this.sendChatNotification = this.sendChatNotification.bind(this)
        this.doUserQuestions = this.doUserQuestions.bind(this)
        this.timer
        this.switchOverlayTimer = null
    }

    componentDidMount() {
        const query = queryString.parse(location.search)
        if (query.showNewUserForm) this.doUserQuestions()
    }
    componentWillUnmount() {
        clearInterval(this.timer)
        clearTimeout(this.switchOverlayTimer)
    }

    setChangingAccounts(isSwitching) {
        clearTimeout(this.switchOverlayTimer)
        if (isSwitching) {
            this.setState({ changingAccounts: true, showSwitchModal: false })
            this.switchOverlayTimer = setTimeout(() => {
                this.setState({ showSwitchModal: true })
            }, 100)
        } else {
            this.setState({ changingAccounts: false, showSwitchModal: false })
        }
    }

    doUserQuestions() {
        if (
            this.props.accountMaster.accountMaster.doneNewUserQuestions ||
            this.props.accountMaster.accountMaster.approved
        )
            return
        setTimeout(() => {
            this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', <NewUserForm />, true, '100vw', 'full'))
        }, 500)
    }

    sendChatNotification(recent) {
        if (!this.props.user.userData.chatOnline) return
        if (this.props.notifications?.permission !== 'granted') return

        this.props.notifications
            .trigger(this.props.siteMaster.siteName + ' Marketing', {
                body: 'Chat Available',
                tag: recent.id
            })
            .then((notification) => {
                if (notification) {
                    notification.addEventListener('click', (e) => {
                        this.props.history.push('/cp/interact/chat?chatId=' + e.target.tag)
                    })
                }
            })
    }

    addNewCampaign() {
        var drawerContent = <DrawerAddCampaignStep1 history={this.props.history} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, false, 'left', drawerContent, true, 500, 'drawer_nopad'))
    }

    goUpgrade() {
        var drawerContent = (
            <UpgradeDrawer
                history={this.props.history}
                close={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null))
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '1000px'))
    }

    goPremiumSupport() {
        var drawerContent = (
            <PremiumSupport
                close={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null))
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'left', drawerContent, true, '400px'))
    }

    changeAccount() {
        this.setState({
            switchAccountContent: (
                <CompanySelect
                    close={() => {
                        this.setState({ switchAccountContent: '' })
                    }}
                    onChangeAccount={(isSwitching) => this.setChangingAccounts(isSwitching !== false)}
                />
            )
        })
        return
    }

    suggestion() {
        var theDrawer = (
            <Suggestion
                finish={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false))
                }}
            ></Suggestion>
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, false, '500px'))
    }

    createNew(type) {
        this.setState({ createOpen: false })
        let drawerContent = ''
        let width = 500
        let classname = ''
        let showClose = true
        switch (type) {
            case 'campaign':
                drawerContent = <CreateCampaign history={this.props.history} />
                classname = 'drawer_nopad'
                showClose = false
                break
            case 'subscriber':
                drawerContent = <AddSubs history={this.props.history} />
                break
            case 'template':
                width = '100vw'
                drawerContent = <CreateTemplate history={this.props.history} />
                break
            case 'automation':
                this.props.dispatch(
                    siteMaster.alterFullpage(
                        <CreateAutomationModal onClose={() => this.props.dispatch(siteMaster.alterFullpage(null))} />
                    )
                )
                break
            case 'landingPage':
                this.props.history.push('/cp/landingpages/add')
                return
            case 'form':
                drawerContent = <CreateForm history={this.props.history} />
                break
        }
        if (drawerContent) {
            this.props.dispatch(
                siteMaster.alterSiteDrawer(true, showClose, 'right', drawerContent, false, width, classname)
            )
        }
    }

    selectTheme(theme) {
        axios.post('/automation/theme/' + theme.id).then((response) => {
            this.setState({
                alertMessage: i18n.t('automation:overview.automationDuplicated'),
                alertOpen: true
            })
            this.props.history.push('/cp/automation/addnew/' + response.data.Automation.id)
        })
    }

    hasPermission(name, method) {
        return PermissionChecker(name, this.props.permissionStore.permissions, method)
    }

    render() {
        if (!this.props.user.loggedIn) return <div></div>

        var loginCnt = 0
        if (
            this.props.user &&
            this.props.user.userData &&
            this.props.user.userData.loginCount &&
            this.props.user.userData.loginCount
        ) {
            loginCnt = this.props.user.userData.loginCount
        }
        var showBilling = true

        if (this.props.siteMaster.hidePricing) showBilling = false
        if (this.props.accountMaster.accountMaster.invoice) showBilling = false
        if (this.props.accountMaster.accountMaster.accountType != 'free') showBilling = false

        let canSwitchAccount = true
        if (this.props.siteMaster.blockSwitchAccount) canSwitchAccount = false

        let isCreditAccount = this.props.accountMaster.accountMaster.billingFrequency == 2
        let creditAccountCredits = this.props.accountMaster.accountMaster.credits || 0
        const canUpgrade =
            this.props.accountMaster.accountMaster.approved && !this.props.accountMaster.accountMaster.deny
        const canCreate =
            this.hasPermission('campaigns', 'write') ||
            this.hasPermission('subscribers', 'write') ||
            this.hasPermission('templates', 'write') ||
            this.hasPermission('automations', 'write') ||
            this.hasPermission('forms', 'write')

        let headerClass = 'cp-header'
        if (this.props.history.location.pathname.indexOf('/cp/conversations/') === 0) {
            headerClass += ' cp-header_fullscreen'
        }

        return (
            <Translation ns='nav'>
                {(t, { i18n }) => (
                    <div>
                        <Banner history={this.props.history} />
                        <Mailchimp2ImportBar />
                        <nav className={headerClass}>
                            <div className='cp-header-start'>
                                <div className='cp-header-start-navigation'>
                                    <BBStandardNav history={this.props.history} counts={this.state.counts} />
                                    <div className='hide-md hide-lg pos-rel'>
                                        <BBMobileCompanySelect
                                            onChangeAccount={(isSwitching) =>
                                                this.setChangingAccounts(isSwitching !== false)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='cp-header-end'>
                                <ul className='cp-header-end-ul'>
                                    {!isCreditAccount && (
                                        <li className='hide-xs hide-sm hide-md'>
                                            {canCreate && (
                                                <ButtonSelect
                                                    headerText={t('translations:createNew')}
                                                    iconLeft={<Icons icon='plus' />}
                                                    overrideButtonClass={true}
                                                    hideIconRight={true}
                                                    className='outline primary'
                                                >
                                                    <ul className='bb_account'>
                                                        {this.hasPermission('campaigns', 'write') && (
                                                            <li
                                                                onClick={() => this.createNew('campaign')}
                                                                data-ph='nav-create-email'
                                                            >
                                                                <Icons
                                                                    icon='mainNavAllCampaigns'
                                                                    style={{ height: 16, width: 16 }}
                                                                    color='#969695'
                                                                />
                                                                {t('translations:campaign')}
                                                            </li>
                                                        )}
                                                        {this.hasPermission('subscribers', 'write') && (
                                                            <li
                                                                onClick={() => this.createNew('subscriber')}
                                                                data-ph='nav-create-subscriber'
                                                            >
                                                                <Icons
                                                                    icon='mainNavAddContact'
                                                                    style={{ height: 16, width: 16 }}
                                                                    color='#969695'
                                                                />
                                                                {t('translations:Subscriber')}
                                                            </li>
                                                        )}
                                                        {this.hasPermission('templates', 'write') && (
                                                            <li
                                                                onClick={() => this.createNew('template')}
                                                                data-ph='nav-create-template'
                                                            >
                                                                <Icons
                                                                    icon='mainNavTemplates'
                                                                    style={{ height: 16, width: 16 }}
                                                                    color='#969695'
                                                                />
                                                                {t('translations:template')}
                                                            </li>
                                                        )}
                                                        {this.hasPermission('automations', 'write') && (
                                                            <li
                                                                onClick={() => this.createNew('automation')}
                                                                data-ph='nav-create-automation'
                                                            >
                                                                <Icons
                                                                    icon='mainNavAutomation'
                                                                    style={{ height: 16, width: 16 }}
                                                                    color='#969695'
                                                                />
                                                                {t('translations:automation')}
                                                            </li>
                                                        )}
                                                        {this.hasPermission('forms', 'write') && (
                                                            <li
                                                                onClick={() => this.createNew('landingPage')}
                                                                data-ph='nav-create-landingPage'
                                                            >
                                                                <Icons
                                                                    icon='mainNavLandingPages'
                                                                    style={{ height: 16, width: 16 }}
                                                                    color='#969695'
                                                                />
                                                                {t('translations:landingPage')}
                                                            </li>
                                                        )}
                                                        {this.hasPermission('forms', 'write') && (
                                                            <li
                                                                onClick={() => this.createNew('form')}
                                                                data-ph='nav-create-form'
                                                            >
                                                                <Icons
                                                                    icon='mainNavForms'
                                                                    style={{ height: 16, width: 16 }}
                                                                    color='#969695'
                                                                />
                                                                {t('translations:form')}
                                                            </li>
                                                        )}
                                                    </ul>
                                                </ButtonSelect>
                                            )}
                                        </li>
                                    )}
                                    {isCreditAccount && (
                                        <li className='hide-xs hide-sm hide-md'>
                                            <Button
                                                text={creditAccountCredits + ' Credits'}
                                                iconRight={<Icons icon='arrowRight' />}
                                                onClick={() => {
                                                    if (canUpgrade) {
                                                        this.goUpgrade()
                                                    }
                                                }}
                                            />
                                        </li>
                                    )}
                                    <li className='hide-xs hide-sm hide-md'>
                                        <BBNotifications
                                            history={this.props.history}
                                            changingAccounts={this.state.changingAccounts}
                                        />
                                    </li>
                                    <li className='hide-xs hide-sm hide-md'>
                                        <AppSwitcher />
                                    </li>
                                    <li className='nav-item-hide last hide-xs'>
                                        <BBAccount
                                            history={this.props.history}
                                            onChangeAccount={(isSwitching) =>
                                                this.setChangingAccounts(isSwitching !== false)
                                            }
                                        />
                                    </li>
                                    <li className='nav-icon hide-md hide-lg mar-l10'>
                                        <BBMobileNav history={this.props.history} />
                                    </li>
                                </ul>
                            </div>
                        </nav>

                        <div className={'connectionError ' + (this.props.siteMaster.connectionError ? 'open' : '')}>
                            <div className='connectionErrorText'>{this.props.siteMaster.connectionError}</div>
                        </div>

                        <section className='nav-main'>{this.props.children}</section>

                        {this.state.drawer}
                        <FeedbackPopups />
                        {this.state.showSwitchModal && (
                            <Modal width='400px' noClickAway={true} blurBg={true}>
                                <div className='text-center'>
                                    <LoadingIcons iconType='2' />
                                    <p className='mar-t15'>{t('switchCompanyLoading')}</p>
                                </div>
                            </Modal>
                        )}
                    </div>
                )}
            </Translation>
        )
    }
}

function withHooks(Component) {
    return function Wrapped(props) {
        const hook = useNotifications()
        return <Component {...props} notifications={hook} />
    }
}

export default withHooks(BBTopNav)
